export enum CardType {
  WATER_LEVEL = 'WATER_LEVEL',
  TEMPERATURE = 'TEMPERATURE',
  DEVICES = 'DEVICES',
  LOCATIONS = 'LOCATIONS',
  CITIES = 'CITIES',
  DOCUMENTS = 'DOCUMENTS',
}
